import React, { useEffect, useRef } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import { clearToken, getToken } from 'resources/api/auth';
//import { ALERT_TYPES, useAlert } from '@etiquette-ui/alert-dialog';

const CONFIG = {
  position: 'bottom-left',
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

// Max consecutive 401s before forcing logout (prevents infinite silent failures)
const MAX_CONSECUTIVE_401 = 3;
const CONSECUTIVE_401_WINDOW_MS = 10000; // 10 seconds

const DEFAULT_STATES = {};

const ErrorManagement = ({ states = DEFAULT_STATES }) => {
  // Track app initialization to avoid premature token clearing
  const [appInitialized, setAppInitialized] = React.useState(false);
  // Track consecutive 401 errors to detect persistent auth failure
  const consecutive401Ref = useRef({ count: 0, firstTimestamp: 0 });

  useEffect(() => {
    // Dar 6 segundos para que la app se inicialice antes de reaccionar a 401s
    const timer = setTimeout(() => setAppInitialized(true), 6000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    for (const key of Object.keys(states)) {
      if (!states[key].state.message) continue;

      const error = states[key].state;
      const resetError = states[key].resetError;
      
      if (typeof error.message === 'string') {
        toast.error(error.message, { toastId: `${key}:${error.timestamp}`, onClose: resetError, ...CONFIG });
        continue;
      }
      if (error.message.status === 500) {
        toast.error('Error interno del servidor', { toastId: `${key}:${error.timestamp}`, onClose: resetError, ...CONFIG });
        continue;
      }
      if (error.message.status === 401) {
        if (appInitialized) {
          if (!getToken()) {
            console.warn('Token ausente + 401 — redirigiendo a login');
            clearToken();
            window.location.href = '/login';
            break;
          }

          // Track consecutive 401s — if too many in a short window, force logout
          const now = Date.now();
          const tracker = consecutive401Ref.current;
          if (now - tracker.firstTimestamp > CONSECUTIVE_401_WINDOW_MS) {
            // Reset window
            tracker.count = 1;
            tracker.firstTimestamp = now;
          } else {
            tracker.count++;
          }

          if (tracker.count >= MAX_CONSECUTIVE_401) {
            console.error(`${MAX_CONSECUTIVE_401}+ errores 401 consecutivos — sesión inválida, redirigiendo a login`);
            clearToken();
            window.location.href = '/login';
            break;
          }

          console.warn(`401 con token presente (${tracker.count}/${MAX_CONSECUTIVE_401}) — reintentando`);
          resetError();
          continue;
        } else {
          console.warn('401 durante inicialización, ignorando para evitar logout prematuro');
          resetError();
          continue;
        }
      }
      toast.error(`${error.message.message}`, {
        toastId: `${key}:${error.timestamp}`,
        onClose: resetError,
        ...CONFIG,
      });
    }
  }, [states, appInitialized]);


  return (
    <ToastContainer
      position="bottom-left"
      autoClose={7000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
    />
  );
};

export default ErrorManagement;
